
export const ACTIVITIES_FILTERS = [{
    type: "UPDATE_POWER",
    filters: [{
        name: "from",
        label: "From",
        type: "integer"
    }, {
        name: "to",
        label: "To",
        type: "integer"
    }]
}, {
    type: "ADD_RUBIES",
    filters: [{
        name: "amount",
        label: "Amount",
        type: "integer"
    }, {
        name: "reason",
        label: "Reason",
        type: "string"
    }]
}, {
    type: "REMOVE_RUBIES",
    filters: [{
        name: "amount",
        label: "Amount",
        type: "integer"
    }, {
        name: "reason",
        label: "Reason",
        type: "string"
    }]
}, {
    type: "CLAIM_DAILY_REWARD",
    filters: [{
        name: "day",
        label: "Streak day",
        type: "integer"
    }, {
        name: "itemId",
        label: "Item Id",
        type: "string"
    }, {
        name: "amount",
        label: "Amount",
        type: "integer"
    }]
}, {
    type: "SET_AVATAR",
    filters: [{
        name: "from",
        label: "Avatar from",
        type: "string"
    }, {
        name: "to",
        label: "Avatar to",
        type: "string"
    }]
}, {
    type: "CHANGED_USERNAME",
    filters: [{
        name: "from",
        label: "Name from",
        type: "string"
    }, {
        name: "to",
        label: "Name to",
        type: "string"
    }]
}, {
    type: "LINK_FACEBOOK",
    filters: [{
        name: "id",
        label: "Provider id",
        type: "string"
    }]
}, {
    type: "LINK_APPLE",
    filters: [{
        name: "id",
        label: "Provider id",
        type: "string"
    }]
}, {
    type: "RECEIVE_AUTOMATED_SQUAD_INVITE",
    filters: [{
        name: "name",
        label: "Alliance name",
        type: "string"
    }]
}, {
    type: "CLAIM_GROWTH_FUND",
    filters: [{
        name: "level",
        label: "Level",
        type: "integer"
    }]
}, {
    type: "REPAIR_BUILDING",
    filters: [{
        name: "id",
        label: "Building id",
        type: "string"
    }]
}, {
    type: "CHANGE_FLAG_PATTERN",
    filters: [{
        name: "from",
        label: "Pattern from",
        type: "string"
    }, {
        name: "to",
        label: "Pattern to",
        type: "string"
    }]
}, {
    type: "BOUGHT_FLAG_PATTERN",
    filters: [{
        name: "id",
        label: "Pattern id",
        type: "string"
    }, {
        name: "type",
        label: "Flag type",
        type: "string"
    }, {
        name: "amount",
        label: "Flag price",
        type: "integer"
    }]
}, {
    type: "EXCHANGE_TECH_POINTS",
    filters: [{
        name: "name",
        label: "Alliance name",
        type: "string"
    }]
}, {
    type: "EXCHANGE_BUNDLE",
    filters: [{
        name: "name",
        label: "Alliance name",
        type: "string"
    }]
}, {
    type: "BUY_GEMS",
    filters: [{
        name: "gems",
        label: "Gems amount",
        type: "integer"
    }, {
        name: "amount",
        label: "Price",
        type: "integer"
    }]
}, {
    type: "ACTIVATE_VIP_PREMIUM",
    filters: [{
        name: "amount",
        label: "Price",
        type: "integer"
    }]
}, {
    type: "BUY_PACK",
    filters: [{
        name: "name",
        label: "Package name",
        type: "string"
    }, {
        name: "amount",
        label: "Price",
        type: "integer"
    }]
}, {
    type: "TRIGGER_OFFER_PACK",
    filters: [{
        name: "name",
        label: "Package name",
        type: "string"
    }]
}, {
    type: "ADD_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }]
}, {
    type: "UPGRADE_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "oldLevel",
        label: "Previous level",
        type: "integer"
    }, {
        name: "newLevel",
        label: "Next level",
        type: "integer"
    }]
}, {
    type: "DOWNGRADE_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "oldLevel",
        label: "Previous level",
        type: "integer"
    }, {
        name: "newLevel",
        label: "Next level",
        type: "integer"
    }]
}, {
    type: "DOWNGRADE_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }]
}, {
    type: "INSTANT_UPGRADE_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "gems",
        label: "Price gems",
        type: "integer"
    }]
}, {
    type: "SCRAP_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "amount",
        label: "Dismantling scraps",
        type: "integer"
    }, {
        name: "rarity",
        label: "Rarity",
        type: "string"
    }]
}, {
    type: "ASSIGN_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "heroId",
        label: "Hero id",
        type: "integer"
    }]
}, {
    type: "UN_ASSIGN_ATTACHMENT",
    filters: [{
        name: "id",
        label: "Attachment id",
        type: "integer"
    }, {
        name: "heroId",
        label: "Hero id",
        type: "integer"
    }]
}, {
    type: "SQUAD_OVERTAKE",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_CREATE",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_JOINED",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_INVITE",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }, {
        name: "from_user_id",
        label: "User id to invite",
        type: "string"
    }]
}, {
    type: "SQUAD_REQUEST_TO_JOIN",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_REQUEST_DECLINE",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_REQUEST_ACCEPT",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_REQUEST_ACCEPT",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }, {
        name: "from_user_id",
        label: "User id",
        type: "string"
    }]
}, {
    type: "SQUAD_KICK_MEMBER",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }, {
        name: "from_user_id",
        label: "User id",
        type: "string"
    }]
}, {
    type: "SQUAD_RERANK_MEMBER",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }, {
        name: "from_user_id",
        label: "User id",
        type: "string"
    }, {
        name: "old_rank",
        label: "Old role",
        type: "string"
    }, {
        name: "new_rank",
        label: "New role",
        type: "string"
    }]
}, {
    type: "SQUAD_LEAVE",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_REQUEST_UNIT_DONATION",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }]
}, {
    type: "SQUAD_DONATE_UNIT",
    filters: [{
        name: "squad_id",
        label: "Alliance id",
        type: "string"
    }, {
        name: "from_user_id",
        label: "User id",
        type: "string"
    }]
}, {
    type: "CLAIM_CRAFTED_MATERIAL",
    filters: [{
        name: "rarity",
        label: "Rarity",
        type: "string"
    }]
}, {
    type: "COLLECT_PRODUCERS",
    filters: [{
        name: "amount",
        label: "Amount",
        type: "integer"
    }, {
        name: "resource",
        label: "Resource",
        type: "string"
    }]
}, {
    type: "ADD_TO_STORAGE_WITH_HQ",
    filters: [{
        name: "amount",
        label: "Amount",
        type: "integer"
    }, {
        name: "resource",
        label: "Resource",
        type: "string"
    }, {
        name: "leftOver",
        label: "Left over",
        type: "integer"
    }]
}, {
    type: "ADD_TO_STORAGE",
    filters: [{
        name: "amount",
        label: "Amount",
        type: "integer"
    }, {
        name: "resource",
        label: "Resource",
        type: "string"
    }, {
        name: "leftOver",
        label: "Left over",
        type: "integer"
    }]
}, {
    type: "BUILDING_UPGRADE",
    filters: [{
        name: "time",
        label: "Upgrade time",
        type: "integer"
    }, {
        name: "from_level",
        label: "Level from",
        type: "integer"
    }, {
        name: "to_level",
        label: "Level to",
        type: "integer"
    }, {
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "BUILDING_INSTANT_UPGRADE",
    filters: [{
        name: "from_level",
        label: "Level from",
        type: "integer"
    }, {
        name: "to_level",
        label: "Level to",
        type: "integer"
    }, {
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "BUILDING_UPGRADE_FINISHED",
    filters: [{
        name: "to_level",
        label: "Level to",
        type: "integer"
    }, {
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "BUILDING_BUY",
    filters: [{
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "BUILDING_BUY_FINISHED",
    filters: [{
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "BUILDING_REMOVE",
    filters: [{
        name: "building_id",
        label: "Building id",
        type: "integer"
    }, {
        name: "unique_id",
        label: "Unique building id",
        type: "string"
    }]
}, {
    type: "UNIT_INSTANT_UPGRADE",
    filters: [{
        name: "id",
        label: "Unity id",
        type: "integer"
    }, {
        name: "to_level",
        label: "Level to",
        type: "integer"
    }, {
        name: "type",
        label: "Type",
        type: "string"
    }]
}];
